import { Origin } from 'inspection-types';

type OriginNode = { origin?: Origin };

export function resolveOrigin(
  node: OriginNode
): Origin.INHERITED | Origin.LOCAL {
  return node.origin === Origin.LOCAL ? Origin.LOCAL : Origin.INHERITED;
}

export function isInherited(node: OriginNode): boolean {
  return resolveOrigin(node) === Origin.INHERITED;
}

export function isLocal(node: OriginNode): boolean {
  return resolveOrigin(node) === Origin.LOCAL;
}
